import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['icon', 'container', 'input', 'tag', 'noResultsMessage']
  
  initialize() {
    this.request = new AbortController()
  }
  
  load() {
    this.showLoadingIcon()
    this.fetchContent()
  }
  
  fetchContent() {
    this.request.abort()
    this.request = new AbortController()
    const url = `${this.url}?${this.params}=${this.inputValue}`
    const request = new Request(url, this.initOptions);

    fetch(request)
      .then(response => response.text())
      .then(html => this.containerTarget.innerHTML = html)
      .then(response => this.showContainer())
      .then(response => this.hideLoadingIcon())
      .catch(error => {
        if (error.name === 'AbortError') {
          // do nothing because another request is coming in
          // console.log('Fetch aborted')
        } else {
          console.error(error)
          this.hideLoadingIcon()
        }
      })
  }
  
  showContainer() {
    if (this.inputTarget.value !== '') {
      this.containerTarget.classList.remove('hide')
    }
  }
  
  showLoadingIcon() {
    this.iconTarget.classList.remove('invisible')
  }
  
  hideLoadingIcon() {
    this.iconTarget.classList.add('invisible')
  }

  get url() {
    return this.data.get('url')
  }
  
  get inputValue() {
    return this.inputTarget.value
  }
  
  get params() {
    return this.inputTarget.dataset.params
  }
  
  get request() {
    return this.data.request
  }
  
  set request(value) {
    return this.data.request = value
  }
  
  get initOptions() {
    return {
      signal: this.request.signal,
      credentials: "same-origin",
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': this.getMetaValue("csrf-token")
      }
    }
  }
  
  getMetaValue(name) {
    const element = document.head.querySelector(`meta[name="${name}"]`)
    return element.getAttribute("content")
  }
}

